module.exports = __webpack_public_path__ + "img/type--3-spans--single-lang--fr.0e52d432.jpg";